module.exports = function() {
  return new Worker(__webpack_public_path__ + "99e5620f89ec3b00594b.worker.js");
};